__turbopack_context__.v({
  "animation": "content-module-scss-module__txN3Yq__animation",
  "animation-complete": "content-module-scss-module__txN3Yq__animation-complete",
  "animation-playing": "content-module-scss-module__txN3Yq__animation-playing",
});
